import { render, staticRenderFns } from "./RelatorioStatusParceiro.vue?vue&type=template&id=0a11b504&scoped=true&"
import script from "./RelatorioStatusParceiro.vue?vue&type=script&lang=js&"
export * from "./RelatorioStatusParceiro.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioStatusParceiro.vue?vue&type=style&index=0&id=0a11b504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a11b504",
  null
  
)

export default component.exports